module.exports = __webpack_public_path__ + "c391b15ee48766562c5a823614752d39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/low_15.jpg
// module id = 1731
// module chunks = 5